var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS45(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2033 11.0934C35.0232 13.0079 35.2239 15.1309 34.7773 17.1652C34.3307 19.1995 33.2591 21.0431 31.7126 22.4381C30.1661 23.8331 28.2221 24.7095 26.1527 24.9447C24.0833 25.1799 21.9921 24.762 20.172 23.7497L11.4064 33.9059C10.7019 34.6104 9.74644 35.0062 8.75016 35.0062C7.75387 35.0062 6.79839 34.6104 6.09391 33.9059C5.38943 33.2014 4.99365 32.246 4.99365 31.2497C4.99365 30.2534 5.38943 29.2979 6.09391 28.5934L16.2502 19.8278C15.2378 18.0077 14.82 15.9166 15.0551 13.8472C15.2903 11.7778 16.1668 9.83374 17.5617 8.28721C18.9567 6.74069 20.8004 5.66911 22.8346 5.2225C24.8689 4.77589 26.9919 4.9766 28.9064 5.79654L22.3439 12.3434L23.2345 16.7653L27.6564 17.6559L34.2033 11.0934Z",
    stroke: "#8D48E8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40625 2.625V10.125",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1562 6.375H4.65625",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90625 16.375V21.375",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40625 18.875H3.40625",
    stroke: "#8D48E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS45);
export default __webpack_public_path__ + "static/media/s4-5.fece18234df2a86efc6d1266b9121aa2.svg";
export { ForwardRef as ReactComponent };